/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.3.1 routes of Lcas::Application.
 * @version 292e33bc6f9e9a03d89adcea8371308a1283485b3456b9cf8231969593e545d1
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /comparison/comparisons/:comparison_id/items/:id/add(.:format)
 * @param {any} comparison_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_comparison_comparison_item_path = /*#__PURE__*/ __route({"comparison_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/communications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_communication_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/communications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_communications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_companies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/completed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_completed_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"completed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_instance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_instances_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/admin_recompute_broken(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_recompute_broken_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"admin_recompute_broken"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/refresh(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_refresh_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/refresh/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_refresh_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"refresh"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /analysis/query_result_sets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analysis_query_result_set_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"query_result_sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/query_result_sets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analysis_query_result_sets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"query_result_sets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analysis_root_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/cleanup(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analysis_root_cleanup_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"cleanup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators-set/:id/impacts_by_dataset(.:format)
 * @param {any} root_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analysis_root_impacts_by_dataset_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators-set"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impacts_by_dataset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analysis_root_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators/:id(.:format)
 * @param {any} root_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analysis_root_indicator_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analysis_root_indicators_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators-set/:id(.:format)
 * @param {any} root_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analysis_root_indicators_set_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators-set"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators-set(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analysis_root_indicators_sets_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators-set"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/*unmatched(.:format)
 * @param {any} unmatched
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_path = /*#__PURE__*/ __route({"unmatched":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[5,[3,"unmatched"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/refresh(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_admin_refresh_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/refresh/communications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_admin_refresh_communications_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"refresh"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/admin/refresh/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_admin_refresh_users_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"refresh"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/analysis/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_analysis_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/case-studies/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_case_study_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/case-study-analysis/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_case_study_analysis_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"case-study-analysis"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/case-study-analysis/:case_study_analysis_id/analysis(.:format)
 * @param {any} case_study_analysis_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_case_study_analysis_analysis_path = /*#__PURE__*/ __route({"case_study_analysis_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"case-study-analysis"],[2,[7,"/"],[2,[3,"case_study_analysis_id"],[2,[7,"/"],[2,[6,"analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/case-study-analysis/:case_study_analysis_id/cancel(.:format)
 * @param {any} case_study_analysis_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_case_study_analysis_cancel_path = /*#__PURE__*/ __route({"case_study_analysis_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"case-study-analysis"],[2,[7,"/"],[2,[3,"case_study_analysis_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/case-study-analysis/:case_study_analysis_id/case_study(.:format)
 * @param {any} case_study_analysis_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_case_study_analysis_case_study_path = /*#__PURE__*/ __route({"case_study_analysis_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"case-study-analysis"],[2,[7,"/"],[2,[3,"case_study_analysis_id"],[2,[7,"/"],[2,[6,"case_study"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/case-study-analysis(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_case_study_analysis_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"case-study-analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/case-study-analysis/:case_study_analysis_id/tracking(.:format)
 * @param {any} case_study_analysis_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_case_study_analysis_tracking_path = /*#__PURE__*/ __route({"case_study_analysis_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"case-study-analysis"],[2,[7,"/"],[2,[3,"case_study_analysis_id"],[2,[7,"/"],[2,[6,"tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/database/refresh(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_database_refresh_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/database/refresh/link_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_database_refresh_link_info_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"refresh"],[2,[7,"/"],[2,[6,"link_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/case-studies/import/:import_id(.:format)
 * @param {any} import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_import_path = /*#__PURE__*/ __route({"import_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[3,"import_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/case-studies/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_import_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/indicators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_indicators_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"indicators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/indicators-sets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_indicators_sets_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"indicators-sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/nodes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_nodes_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/database_upgrade_chronicles/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_database_database_upgrade_chronicle_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"database_upgrade_chronicles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"blazer"]]);

/**
 * Generates rails route to
 * /blazer/queries/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_cancel_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/checks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_check_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/checks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_checks_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"checks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blazer/dashboards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_dashboard_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/dashboards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_dashboards_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_docs_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/checks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_edit_check_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/dashboards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_edit_dashboard_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_edit_query_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/checks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_new_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"checks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/dashboards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_new_dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_new_query_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_query_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/dashboards/:id/refresh(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_refresh_dashboard_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/:id/refresh(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_refresh_query_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_root_path = /*#__PURE__*/ __route({}, [2,[2,[7,"/"],[6,"blazer"]],[7,"/"]]);

/**
 * Generates rails route to
 * /blazer/checks/:id/run(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_run_check_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/run(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_run_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/schema(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_schema_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blazer/queries/tables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blazer_tables_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"blazer"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"tables"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:ref_id/bookmark(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookmark_make_cs_item_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"bookmark"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/database_upgrade_chronicles/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_database_database_upgrade_chronicle_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"database_upgrade_chronicles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:ref_id/check(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_make_db_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /check/websockets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_websockets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"check"],[2,[7,"/"],[2,[6,"websockets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies/:ref_id/clear-template(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_template_make_cs_case_study_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"clear-template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/compare_db_modules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compare_db_modules_database_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"compare_db_modules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/:id/compare_version(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compare_version_database_db_module_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"compare_version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparison_comparison_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/:comparison_id/compute(.:format)
 * @param {any} comparison_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparison_comparison_compute_path = /*#__PURE__*/ __route({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"compute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/:comparison_id/indicators/:id(.:format)
 * @param {any} comparison_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparison_comparison_indicator_path = /*#__PURE__*/ __route({"comparison_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/:comparison_id/indicators_sets/:id(.:format)
 * @param {any} comparison_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparison_comparison_indicators_set_path = /*#__PURE__*/ __route({"comparison_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/:comparison_id/indicators_sets/:indicators_set_id/spreadsheet(.:format)
 * @param {any} comparison_id
 * @param {any} indicators_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparison_comparison_indicators_set_spreadsheet_path = /*#__PURE__*/ __route({"comparison_id":{"r":true},"indicators_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"spreadsheet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/:comparison_id/items/:id(.:format)
 * @param {any} comparison_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparison_comparison_item_path = /*#__PURE__*/ __route({"comparison_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/:comparison_id/items(.:format)
 * @param {any} comparison_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparison_comparison_items_path = /*#__PURE__*/ __route({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies/compute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compute_make_cs_case_studies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[6,"compute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/containers/compute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compute_make_cs_containers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"containers"],[2,[7,"/"],[2,[6,"compute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/energy-consumptions/compute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compute_make_cs_energy_consumptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"energy-consumptions"],[2,[7,"/"],[2,[6,"compute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/flows/compute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compute_make_cs_flows_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[6,"compute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/compute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compute_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"compute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/modules/compute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compute_make_cs_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"compute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/systems/compute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compute_make_cs_systems_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"compute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/transport-steps/compute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compute_make_cs_transport_steps_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"transport-steps"],[2,[7,"/"],[2,[6,"compute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/copy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/scenarios/copy_scenarios(.:format)
 * @param {any} db_module_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_scenarios_make_db_module_scenarios_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[6,"copy_scenarios"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/status/counters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counters_api_v1_status_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[6,"counters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/modules/create_from_scenario(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_from_scenario_make_cs_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"create_from_scenario"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /case-studies/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cs_case_study_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /csp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csp_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"csp"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/cut(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cut_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"cut"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /data/lcas_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_lcas_info_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"lcas_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /database/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/database_upgrade_chronicles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_database_upgrade_chronicles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"database_upgrade_chronicles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database/database_upgrade_steps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_database_upgrade_step_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"database_upgrade_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/database_upgrade_steps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_database_upgrade_steps_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"database_upgrade_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database/flows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_db_flow_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_db_flows_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"flows"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_db_module_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/:db_module_id/details(.:format)
 * @param {any} db_module_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_db_module_details_path = /*#__PURE__*/ __route({"db_module_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"db_module_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/:db_module_id/export(.:format)
 * @param {any} db_module_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_db_module_export_path = /*#__PURE__*/ __route({"db_module_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"db_module_id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/db_module_substitutions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_db_module_substitution_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"db_module_substitutions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/db_module_substitutions/:db_module_substitution_id/details(.:format)
 * @param {any} db_module_substitution_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_db_module_substitution_details_path = /*#__PURE__*/ __route({"db_module_substitution_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"db_module_substitutions"],[2,[7,"/"],[2,[3,"db_module_substitution_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/db_module_substitutions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_db_module_substitutions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"db_module_substitutions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database/modules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database/flows/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_flow_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/flows/categories/:flow_category_id/expand(.:format)
 * @param {any} flow_category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_flow_category_expand_path = /*#__PURE__*/ __route({"flow_category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"flow_category_id"],[2,[7,"/"],[2,[6,"expand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/flows/categories/:flow_category_id/nodes(.:format)
 * @param {any} flow_category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_flow_category_nodes_path = /*#__PURE__*/ __route({"flow_category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"flow_category_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_indicator_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators/:indicator_id/details(.:format)
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_indicator_details_path = /*#__PURE__*/ __route({"indicator_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"indicator_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_indicators_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators_sets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_indicators_set_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators_sets/:indicators_set_id/details(.:format)
 * @param {any} indicators_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_indicators_set_details_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators_sets/:indicators_set_id/expand(.:format)
 * @param {any} indicators_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_indicators_set_expand_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"expand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators_sets/:indicators_set_id/infos(.:format)
 * @param {any} indicators_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_indicators_set_infos_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators_sets/:indicators_set_id/nodes(.:format)
 * @param {any} indicators_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_indicators_set_nodes_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators_sets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_indicators_sets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators_sets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators_sets_indicators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_indicators_sets_indicator_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators_sets_indicators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_module_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/categories/:module_category_id/expand(.:format)
 * @param {any} module_category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_module_category_expand_path = /*#__PURE__*/ __route({"module_category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"module_category_id"],[2,[7,"/"],[2,[6,"expand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/categories/:module_category_id/nodes(.:format)
 * @param {any} module_category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_module_category_nodes_path = /*#__PURE__*/ __route({"module_category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"module_category_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/tags/:tag_id/details(.:format)
 * @param {any} tag_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_tag_details_path = /*#__PURE__*/ __route({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_tags_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database/units/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_unit_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/units/:unit_id/details(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_unit_details_path = /*#__PURE__*/ __route({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/unit_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_unit_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"unit_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/unit_groups/:unit_group_id/details(.:format)
 * @param {any} unit_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_unit_group_details_path = /*#__PURE__*/ __route({"unit_group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"unit_groups"],[2,[7,"/"],[2,[3,"unit_group_id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/unit_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_unit_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"unit_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/energy-consumptions/db_modules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const db_modules_make_cs_energy_consumptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"energy-consumptions"],[2,[7,"/"],[2,[6,"db_modules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/transport-steps/db_modules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const db_modules_make_cs_transport_steps_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"transport-steps"],[2,[7,"/"],[2,[6,"db_modules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /debug/event_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_event_logs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"event_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /debug/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_jobs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /debug/locked_tuples(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_locked_tuples_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"locked_tuples"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/debug(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_pages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"debug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /debug/puma_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_puma_stats_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"puma_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /debug/running_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_running_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"running_queries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /debug/running_queries/:pid(.:format)
 * @param {any} pid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_running_query_path = /*#__PURE__*/ __route({"pid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"running_queries"],[2,[7,"/"],[2,[3,"pid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/scenarios/delete_multi_destroy(.:format)
 * @param {any} db_module_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_multi_destroy_make_db_module_scenarios_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[6,"delete_multi_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_root_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_root_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/library(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_root_library_index_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/nodes/:ref_id(.:format)
 * @param {any} root_ref_id
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_root_node_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/nodes(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_root_nodes_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/search(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_root_search_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/tree(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_root_tree_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"tree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/tree(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_root_tree_index_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"tree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/destroy_completed(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_completed_user_notifications_path = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"destroy_completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/modules/:ref_id/destroy_linked_module(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_linked_module_make_cs_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"destroy_linked_module"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/communications/:id/details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_admin_communication_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_admin_company_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/:id/details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_admin_instance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/flows/:id/details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_database_db_flow_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/nodes/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_project_nodes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /project/root/:root_ref_id/nodes/details(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_project_root_nodes_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/:id/documentation_sidebar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documentation_sidebar_database_db_module_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documentation_sidebar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/:id/download_case_study_source(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_case_study_source_database_db_module_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_case_study_source"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/communications/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_admin_communication_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_admin_company_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_admin_instance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/duplicate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/communications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_communication_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_company_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_instance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_analysis_root_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators/:id/edit(.:format)
 * @param {any} root_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_analysis_root_indicator_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators-set/:id/edit(.:format)
 * @param {any} root_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_analysis_root_indicators_set_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators-set"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:ref_id/edit_available_date(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_available_date_make_db_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit_available_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/settings/edit_communication_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_communication_settings_users_account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"edit_communication_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_comparison_comparison_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/:comparison_id/items/:id/edit(.:format)
 * @param {any} comparison_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_comparison_comparison_item_path = /*#__PURE__*/ __route({"comparison_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/database_upgrade_steps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_database_database_upgrade_step_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"database_upgrade_steps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/db_module_substitutions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_database_db_module_substitution_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"db_module_substitutions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators_sets_indicators/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_database_indicators_sets_indicator_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators_sets_indicators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/settings/edit_default_color_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_default_color_settings_users_account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"edit_default_color_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/settings/edit_default_unit_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_default_unit_settings_users_account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"edit_default_unit_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:ref_id/edit_deprecated_date(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_deprecated_date_make_db_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit_deprecated_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_design_root_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/nodes/:ref_id/edit(.:format)
 * @param {any} root_ref_id
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_design_root_node_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/edit_expiration_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_expiration_date_admin_companies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"edit_expiration_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/edit_expiration_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_expiration_date_admin_instances_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[6,"edit_expiration_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/edit_expiration_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_expiration_date_admin_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit_expiration_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:ref_id/edit_icv(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_icv_make_db_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit_icv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/edit_line(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_line_admin_company_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_line"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/:id/edit_line(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_line_admin_instance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_line"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit_line(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_line_admin_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_line"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/edit_line(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_line_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"edit_line"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_case_study_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/containers/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_container_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"containers"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/energy-consumptions/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_energy_consumption_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"energy-consumptions"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/flows/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_flow_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/folders/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_folder_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:cs_item_ref_id/statuses/:id/edit(.:format)
 * @param {any} cs_item_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_item_status_path = /*#__PURE__*/ __route({"cs_item_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"cs_item_ref_id"],[2,[7,"/"],[2,[6,"statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/modules/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/phases/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_phase_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"phases"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/projects/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_project_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/systems/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_system_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/transport-steps/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_cs_transport_step_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"transport-steps"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-flows/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_db_flow_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-flows"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:ref_id/edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_db_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/scenarios/:id/edit(.:format)
 * @param {any} db_module_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_db_module_scenario_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_indicator_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/:indicator_id/contributors/edit(.:format)
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_indicator_indicator_contributors_path = /*#__PURE__*/ __route({"indicator_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"indicator_id"],[2,[7,"/"],[2,[6,"contributors"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_indicators_set_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:indicators_set_id/normalizations/:id/edit(.:format)
 * @param {any} indicators_set_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_indicators_set_normalization_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"normalizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:indicators_set_id/ponderations/:id/edit(.:format)
 * @param {any} indicators_set_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_indicators_set_ponderation_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"ponderations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/tags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_make_tag_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/edit_manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_manager_admin_companies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"edit_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/edit_manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_manager_admin_instances_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[6,"edit_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/edit_manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_manager_admin_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_pages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/account/settings/edit_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_users_account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"edit_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/user_tokens/edit(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_user_tokens_path = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_tokens"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/backup_factor/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_users_account_backup_factor_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"backup_factor"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/notification_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_users_account_notification_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"notification_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_users_account_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/second_factor/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_users_account_second_factor_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"second_factor"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_users_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/edit_workflow_and_publication_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_workflow_and_publication_status_make_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[6,"edit_workflow_and_publication_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /case-studies/:ref_id/parameters/enable_parameters_set(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_parameters_set_parameters_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"parameters"],[2,[7,"/"],[2,[6,"enable_parameters_set"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators-set/:id/expand(.:format)
 * @param {any} root_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expand_analysis_root_indicators_set_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators-set"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"expand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/library/:category_id/expand(.:format)
 * @param {any} root_ref_id
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expand_design_root_library_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"expand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/tree/:ref_id/expand(.:format)
 * @param {any} root_ref_id
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expand_design_root_tree_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"tree"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"expand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/nodes/:ref_id/expand(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expand_project_node_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"expand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/root/:root_ref_id/nodes/:ref_id/expand(.:format)
 * @param {any} root_ref_id
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expand_project_root_node_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"expand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/database_upgrade_chronicles/:id/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_database_database_upgrade_chronicle_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"database_upgrade_chronicles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies/:ref_id/export/:export_format(.:format)
 * @param {any} ref_id
 * @param {any} export_format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_make_cs_case_study_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"export_format":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[3,"export_format"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /case-studies/:ref_id/parameters/export(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_parameters_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"parameters"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/library/flows(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flows_design_root_library_index_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"flows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:ref_id/forward(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forward_make_cs_item_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"forward"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"good_job"]]);

/**
 * Generates rails route to
 * /good_job/batches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_batch_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"batches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/batches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_batches_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"batches"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/cleaner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_cleaner_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cleaner"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_cron_entries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_cron_entry_path = /*#__PURE__*/ __route({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key/disable(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_disable_cron_entry_path = /*#__PURE__*/ __route({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/discard(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_discard_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key/enable(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_enable_cron_entry_path = /*#__PURE__*/ __route({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/cron_entries/:cron_key/enqueue(.:format)
 * @param {any} cron_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_enqueue_cron_entry_path = /*#__PURE__*/ __route({"cron_key":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"cron_entries"],[2,[7,"/"],[2,[3,"cron_key"],[2,[7,"/"],[2,[6,"enqueue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/force_discard(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_force_discard_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"force_discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/frontend/modules/:version/:id(.:format)
 * @param {any} version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_frontend_module_path = /*#__PURE__*/ __route({"version":{"r":true,"d":"4-19-2"},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"frontend"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"version"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/frontend/static/:version/:id(.:format)
 * @param {any} version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_frontend_static_path = /*#__PURE__*/ __route({"version":{"r":true,"d":"4-19-2"},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"frontend"],[2,[7,"/"],[2,[6,"static"],[2,[7,"/"],[2,[3,"version"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_jobs_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/mass_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_mass_update_jobs_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/metrics/job_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_metrics_job_status_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"job_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/metrics/primary_nav(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_metrics_primary_nav_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"primary_nav"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/pauses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_pauses_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"pauses"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/performance/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_performance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"performance"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /good_job/performance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_performance_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"performance"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/processes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_processes_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"processes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/reschedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_reschedule_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/batches/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_retry_batch_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"batches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/jobs/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_retry_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"good_job"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /good_job/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const good_job_root_path = /*#__PURE__*/ __route({}, [2,[2,[7,"/"],[6,"good_job"]],[7,"/"]]);

/**
 * Generates rails route to
 * /health(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /make/replace/cs_modules/help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_make_replace_cs_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"replace"],[2,[7,"/"],[2,[6,"cs_modules"],[2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/replace/cs_transport_steps/help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_make_replace_cs_transport_steps_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"replace"],[2,[7,"/"],[2,[6,"cs_transport_steps"],[2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /home/communications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_communication_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /home/communications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_communications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /home/replace_statistics_card(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_replace_statistics_card_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"replace_statistics_card"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/:id/impact_indicators_list(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const impact_indicators_list_database_db_module_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impact_indicators_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/impersonate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const impersonate_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impersonate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_database_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_make_cs_case_studies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /case-studies/:ref_id/parameters/import(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_parameters_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"parameters"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instances_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"instances"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /database/database_upgrade_steps/:id/launch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const launch_database_database_upgrade_step_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"database_upgrade_steps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"launch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/completed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_completed_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"completed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_case_studies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_case_study_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies/:cs_case_study_ref_id/templates_collection(.:format)
 * @param {any} cs_case_study_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_case_study_templates_collection_index_path = /*#__PURE__*/ __route({"cs_case_study_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"cs_case_study_ref_id"],[2,[7,"/"],[2,[6,"templates_collection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/containers/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_container_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"containers"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/containers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_containers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"containers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/energy-consumptions/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_energy_consumption_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"energy-consumptions"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/energy-consumptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_energy_consumptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"energy-consumptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/flows/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_flow_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_flows_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"flows"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/folders/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_folder_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/folders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_folders_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_item_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:cs_item_ref_id/statuses/:id(.:format)
 * @param {any} cs_item_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_item_status_path = /*#__PURE__*/ __route({"cs_item_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"cs_item_ref_id"],[2,[7,"/"],[2,[6,"statuses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:cs_item_ref_id/statuses(.:format)
 * @param {any} cs_item_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_item_statuses_path = /*#__PURE__*/ __route({"cs_item_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"cs_item_ref_id"],[2,[7,"/"],[2,[6,"statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:cs_item_ref_id/permissions/:id(.:format)
 * @param {any} cs_item_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_item_users_cs_item_path = /*#__PURE__*/ __route({"cs_item_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"cs_item_ref_id"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:cs_item_ref_id/permissions(.:format)
 * @param {any} cs_item_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_item_users_cs_items_path = /*#__PURE__*/ __route({"cs_item_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"cs_item_ref_id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/modules/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/modules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"modules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/phases/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_phase_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"phases"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/phases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_phases_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"phases"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/projects/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_project_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_projects_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/systems/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_system_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_systems_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"systems"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/transport-steps/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_transport_step_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"transport-steps"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/transport-steps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_cs_transport_steps_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"transport-steps"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/db-flows/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_flow_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-flows"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_flows_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-flows"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db_module_from_cs_case_studies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_module_from_cs_case_studies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db_module_from_cs_case_studies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/flows/:id(.:format)
 * @param {any} db_module_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_module_icv_flow_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/categories/:id(.:format)
 * @param {any} db_module_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_module_icv_flow_category_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/categories/:icv_flow_category_id/expand(.:format)
 * @param {any} db_module_ref_id
 * @param {any} icv_flow_category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_module_icv_flow_category_expand_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"icv_flow_category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"icv_flow_category_id"],[2,[7,"/"],[2,[6,"expand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/categories/:icv_flow_category_id/nodes(.:format)
 * @param {any} db_module_ref_id
 * @param {any} icv_flow_category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_module_icv_flow_category_nodes_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"icv_flow_category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"icv_flow_category_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/flows(.:format)
 * @param {any} db_module_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_module_icv_flow_index_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"flows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/scenarios/:id(.:format)
 * @param {any} db_module_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_module_scenario_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/scenarios(.:format)
 * @param {any} db_module_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_module_scenarios_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"scenarios"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicator_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/:indicator_id/contributors(.:format)
 * @param {any} indicator_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicator_indicator_contributors_path = /*#__PURE__*/ __route({"indicator_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"indicator_id"],[2,[7,"/"],[2,[6,"contributors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/:indicator_id/contributors/flows/:id(.:format)
 * @param {any} indicator_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicator_indicator_contributors_contribution_flow_path = /*#__PURE__*/ __route({"indicator_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"indicator_id"],[2,[7,"/"],[2,[6,"contributors"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/:indicator_id/contributors/categories/:id(.:format)
 * @param {any} indicator_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicator_indicator_contributors_contribution_flow_category_path = /*#__PURE__*/ __route({"indicator_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"indicator_id"],[2,[7,"/"],[2,[6,"contributors"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/:indicator_id/contributors/categories/:contribution_flow_category_id/expand(.:format)
 * @param {any} indicator_id
 * @param {any} contribution_flow_category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicator_indicator_contributors_contribution_flow_category_expand_path = /*#__PURE__*/ __route({"indicator_id":{"r":true},"contribution_flow_category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"indicator_id"],[2,[7,"/"],[2,[6,"contributors"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"contribution_flow_category_id"],[2,[7,"/"],[2,[6,"expand"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/:indicator_id/contributors/categories/:contribution_flow_category_id/nodes(.:format)
 * @param {any} indicator_id
 * @param {any} contribution_flow_category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicator_indicator_contributors_contribution_flow_category_nodes_path = /*#__PURE__*/ __route({"indicator_id":{"r":true},"contribution_flow_category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"indicator_id"],[2,[7,"/"],[2,[6,"contributors"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"contribution_flow_category_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicators_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicators_set_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:indicators_set_id/normalizations/:id(.:format)
 * @param {any} indicators_set_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicators_set_normalization_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"normalizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:indicators_set_id/normalizations(.:format)
 * @param {any} indicators_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicators_set_normalizations_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"normalizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:indicators_set_id/ponderations/:id(.:format)
 * @param {any} indicators_set_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicators_set_ponderation_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"ponderations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:indicators_set_id/ponderations(.:format)
 * @param {any} indicators_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicators_set_ponderations_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"ponderations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_indicators_sets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/refresh/:instance_name(.:format)
 * @param {any} instance_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_refresh_path = /*#__PURE__*/ __route({"instance_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"refresh"],[2,[7,"/"],[2,[3,"instance_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/refresh(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_refresh_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_tag_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_tags_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /home/communications/:id/mark_as_read(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_read_home_communication_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies/:ref_id/mark-template(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_template_make_cs_case_study_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"mark-template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/library/modules(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modules_design_root_library_index_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"modules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/move(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/multi_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_destroy_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"multi_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/scenarios/multi_destroy(.:format)
 * @param {any} db_module_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_destroy_make_db_module_scenarios_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[6,"multi_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/multi_destroy_message(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_destroy_message_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"multi_destroy_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/multi_edit_available_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_edit_available_date_make_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[6,"multi_edit_available_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /case-studies/:ref_id/parameters/multi_edit(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_edit_parameters_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"parameters"],[2,[7,"/"],[2,[6,"multi_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/multi_fix_broken(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_fix_broken_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"multi_fix_broken"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/multi_prune_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_prune_items_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"multi_prune_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/flows/multi_replace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_replace_make_cs_flows_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[6,"multi_replace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/multi_update_available_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_update_available_date_make_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[6,"multi_update_available_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/multi_update_version(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_update_version_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"multi_update_version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/communications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_communication_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_company_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_instance_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_analysis_root_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators/new(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_analysis_root_indicator_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators-set/new(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_analysis_root_indicators_set_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators-set"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_comparison_comparison_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comparison/comparisons/:comparison_id/items/new(.:format)
 * @param {any} comparison_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_comparison_comparison_item_path = /*#__PURE__*/ __route({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparison"],[2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_database_category_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/database_upgrade_steps/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_database_database_upgrade_step_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"database_upgrade_steps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/db_module_substitutions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_database_db_module_substitution_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"db_module_substitutions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_design_root_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/nodes/new(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_design_root_node_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/modules/new_energetic_mix(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_energetic_mix_make_cs_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"new_energetic_mix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/replace/cs_modules/new_energetic_mix(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_energetic_mix_make_replace_cs_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"replace"],[2,[7,"/"],[2,[6,"cs_modules"],[2,[7,"/"],[2,[6,"new_energetic_mix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_case_study_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/containers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_container_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"containers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/energy-consumptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_energy_consumption_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"energy-consumptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/flows/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_flow_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/folders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_folder_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:cs_item_ref_id/statuses/new(.:format)
 * @param {any} cs_item_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_item_status_path = /*#__PURE__*/ __route({"cs_item_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"cs_item_ref_id"],[2,[7,"/"],[2,[6,"statuses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/modules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_module_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/phases/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_phase_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"phases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/projects/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_project_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/systems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_system_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/transport-steps/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_cs_transport_step_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"transport-steps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-flows/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_db_flow_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-flows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_db_module_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/scenarios/new(.:format)
 * @param {any} db_module_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_db_module_scenario_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_indicator_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_indicators_set_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:indicators_set_id/normalizations/new(.:format)
 * @param {any} indicators_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_indicators_set_normalization_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"normalizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:indicators_set_id/ponderations/new(.:format)
 * @param {any} indicators_set_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_indicators_set_ponderation_path = /*#__PURE__*/ __route({"indicators_set_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"indicators_set_id"],[2,[7,"/"],[2,[6,"ponderations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/tags/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_make_tag_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/flows/new_multi_replace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_multi_replace_make_cs_flows_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[6,"new_multi_replace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_pages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /make/db_module_from_cs_case_studies/new_preset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_preset_make_db_module_from_cs_case_studies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db_module_from_cs_case_studies"],[2,[7,"/"],[2,[6,"new_preset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tickets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tickets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/demo/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_users_demo_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/library/:category_id/node(.:format)
 * @param {any} root_ref_id
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const node_design_root_library_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"node"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/tree/:ref_id/node(.:format)
 * @param {any} root_ref_id
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const node_design_root_tree_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"tree"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"node"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators-set/nodes(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nodes_analysis_root_indicators_sets_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators-set"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/library/:category_id/nodes(.:format)
 * @param {any} root_ref_id
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nodes_design_root_library_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/tree/:ref_id/nodes(.:format)
 * @param {any} root_ref_id
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nodes_design_root_tree_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"tree"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/nodes/:ref_id/nodes(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nodes_project_node_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/root/:root_ref_id/nodes/:ref_id/nodes(.:format)
 * @param {any} root_ref_id
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nodes_project_root_node_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ui/library_modules/:root_ref_id/categories/:category_id/nodes(.:format)
 * @param {any} root_ref_id
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nodes_ui_category_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ui"],[2,[7,"/"],[2,[6,"library_modules"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /case-studies/:ref_id/parameters/:id(.:format)
 * @param {any} ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parameter_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"parameters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /case-studies/:ref_id/parameter_values/:id(.:format)
 * @param {any} ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parameter_value_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"parameter_values"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /case-studies/:ref_id/parameters(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parameters_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"parameters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /case-studies/:ref_id/parameters_sets/:id(.:format)
 * @param {any} ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parameters_set_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"parameters_sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /case-studies/:ref_id/parameters_sets(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parameters_sets_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"parameters_sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/paste(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paste_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"paste"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pghero
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"pghero"]]);

/**
 * Generates rails route to
 * /pghero(/:database)/connection_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_connection_stats_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"connection_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_connections_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"connections"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/cpu_usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_cpu_usage_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"cpu_usage"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/enable_query_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_enable_query_stats_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"enable_query_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/explain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_explain_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"explain"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/free_space_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_free_space_stats_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"free_space_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/index_bloat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_index_bloat_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"index_bloat"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/kill(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_kill_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"kill"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/kill_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_kill_all_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"kill_all"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/kill_long_running_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_kill_long_running_queries_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"kill_long_running_queries"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/live_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_live_queries_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"live_queries"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/load_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_load_stats_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"load_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/maintenance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_maintenance_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"maintenance"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_queries_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/query_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_query_stats_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"query_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/space/:relation(.:format)
 * @param {any} relation
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_relation_space_path = /*#__PURE__*/ __route({"database":{},"relation":{"r":true},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"space"],[2,[7,"/"],[2,[3,"relation"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/replication_lag_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_replication_lag_stats_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"replication_lag_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/reset_query_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_reset_query_stats_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"reset_query_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero/(:database)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_root_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[2,[1,[3,"database"]],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/queries/:query_hash(.:format)
 * @param {any} query_hash
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_show_query_path = /*#__PURE__*/ __route({"database":{},"query_hash":{"r":true},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"queries"],[2,[7,"/"],[2,[3,"query_hash"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/space(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_space_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"space"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/system(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_system_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"system"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/system_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_system_stats_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"system_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pghero(/:database)/tune(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pg_hero_tune_path = /*#__PURE__*/ __route({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[6,"pghero"]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"tune"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /database/modules/post_compare_db_modules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_compare_db_modules_database_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"post_compare_db_modules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/scenarios/post_copy_scenarios(.:format)
 * @param {any} db_module_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_copy_scenarios_make_db_module_scenarios_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[6,"post_copy_scenarios"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/modules/post_import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_import_database_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"post_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db_module_from_cs_case_studies/post_preset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_preset_make_db_module_from_cs_case_studies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db_module_from_cs_case_studies"],[2,[7,"/"],[2,[6,"post_preset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/replace/cs_modules/post_replace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_replace_make_replace_cs_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"replace"],[2,[7,"/"],[2,[6,"cs_modules"],[2,[7,"/"],[2,[6,"post_replace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/replace/cs_transport_steps/post_replace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_replace_make_replace_cs_transport_steps_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"replace"],[2,[7,"/"],[2,[6,"cs_transport_steps"],[2,[7,"/"],[2,[6,"post_replace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/modules/preload_scenario(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preload_scenario_make_cs_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"modules"],[2,[7,"/"],[2,[6,"preload_scenario"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/database_upgrade_chronicles/:id/preview_cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_cancel_database_database_upgrade_chronicle_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"database_upgrade_chronicles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"project"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /project/nodes/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_node_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /project/nodes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_nodes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /project/root/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_root_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /project/root/:root_ref_id/nodes/:ref_id(.:format)
 * @param {any} root_ref_id
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_root_node_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/root/:root_ref_id/nodes(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_root_nodes_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-flows/publish(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_make_db_flows_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-flows"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/publish(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_make_indicators_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/publish(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_make_indicators_sets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/systems/quick_insert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_insert_make_cs_systems_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"quick_insert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pg_extras
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_pg_extras_web_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"pg_extras"]]);

/**
 * Generates rails route to
 * /pg_extras/actions/add_extensions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_pg_extras_web_add_extensions_action_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"pg_extras"]],[7,"/"]],[2,[6,"actions"],[2,[7,"/"],[2,[6,"add_extensions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pg_extras/actions/kill_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_pg_extras_web_kill_all_action_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"pg_extras"]],[7,"/"]],[2,[6,"actions"],[2,[7,"/"],[2,[6,"kill_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pg_extras/actions/pg_stat_statements_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_pg_extras_web_pg_stat_statements_reset_action_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"pg_extras"]],[7,"/"]],[2,[6,"actions"],[2,[7,"/"],[2,[6,"pg_stat_statements_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pg_extras/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_pg_extras_web_queries_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"pg_extras"]],[7,"/"]],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pg_extras/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_pg_extras_web_root_path = /*#__PURE__*/ __route({}, [2,[2,[7,"/"],[6,"pg_extras"]],[7,"/"]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /redirect/cs_items/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirect_cs_item_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/reference_flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reference_flows_make_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[6,"reference_flows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/communications/refresh(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_admin_communications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:ref_id/refresh_impacts(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_impacts_make_db_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"refresh_impacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/reinitialize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reinitialize_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"reinitialize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/replace/cs_modules/replace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replace_make_replace_cs_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"replace"],[2,[7,"/"],[2,[6,"cs_modules"],[2,[7,"/"],[2,[6,"replace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/replace/cs_transport_steps/replace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replace_make_replace_cs_transport_steps_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"replace"],[2,[7,"/"],[2,[6,"cs_transport_steps"],[2,[7,"/"],[2,[6,"replace"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/settings/reset_default_color_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_default_color_settings_users_account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"reset_default_color_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:ref_id/reset_item_path(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_item_path_make_cs_item_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"reset_item_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /api-docs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rswag_api_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"api-docs"]]);

/**
 * Generates rails route to
 * /api-docs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rswag_ui_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"api-docs"]]);

/**
 * Generates rails route to
 * /make/db-modules/:db_module_ref_id/scenarios/scenarios_list(.:format)
 * @param {any} db_module_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scenarios_list_make_db_module_scenarios_path = /*#__PURE__*/ __route({"db_module_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"db_module_ref_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[6,"scenarios_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/nodes/:ref_id/search(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_project_node_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/nodes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_project_nodes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /project/root/:root_ref_id/nodes/search(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_project_root_nodes_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:ref_id/share(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const share_make_cs_item_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/case-studies/show_template_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_template_comments_make_cs_case_studies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"case-studies"],[2,[7,"/"],[2,[6,"show_template_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators-set/:id/impacts_by_dataset/spreadsheet(.:format)
 * @param {any} root_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spreadsheet_analysis_root_impacts_by_dataset_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators-set"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impacts_by_dataset"],[2,[7,"/"],[2,[6,"spreadsheet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators/:id/spreadsheet(.:format)
 * @param {any} root_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spreadsheet_analysis_root_indicator_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"spreadsheet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analysis/root/:root_ref_id/indicators-set/:id/spreadsheet(.:format)
 * @param {any} root_ref_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spreadsheet_analysis_root_indicators_set_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"indicators-set"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"spreadsheet"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/stop_impersonate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stop_impersonate_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"stop_impersonate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password/strength(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const strength_users_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"strength"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /design/root/:root_ref_id/library/systems(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systems_design_root_library_index_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"design"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tickets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tickets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /session/timeout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeout_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"timeout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/:id/toggle-archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_archive_admin_instance_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle-archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/projects/:ref_id/toggle-archive(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_archive_make_cs_project_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"toggle-archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators/:id/toggle-archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_archive_make_indicator_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle-archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/indicators_sets/:id/toggle-archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_archive_make_indicators_set_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle-archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:ref_id/track(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const track_make_cs_item_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"track"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/nodes/:ref_id/tree(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tree_project_node_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"tree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/nodes/tree(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tree_project_nodes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[6,"tree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /project/root/:root_ref_id/nodes/:ref_id/tree(.:format)
 * @param {any} root_ref_id
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tree_project_root_node_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"tree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project/root/:root_ref_id/nodes/tree(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tree_project_root_nodes_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"project"],[2,[7,"/"],[2,[6,"root"],[2,[7,"/"],[2,[3,"root_ref_id"],[2,[7,"/"],[2,[6,"nodes"],[2,[7,"/"],[2,[6,"tree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ui/broken_items/:ref_id(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ui_broken_item_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ui"],[2,[7,"/"],[2,[6,"broken_items"],[2,[7,"/"],[2,[3,"ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ui/id/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ui_id_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ui"],[2,[7,"/"],[2,[6,"id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ui/interactive_breadcrumb/:ref_ids(.:format)
 * @param {any} ref_ids
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ui_interactive_breadcrumb_path = /*#__PURE__*/ __route({"ref_ids":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ui"],[2,[7,"/"],[2,[6,"interactive_breadcrumb"],[2,[7,"/"],[2,[3,"ref_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ui/interactive_breadcrumb_category/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ui_interactive_breadcrumb_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ui"],[2,[7,"/"],[2,[6,"interactive_breadcrumb_category"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ui/library_modules/:root_ref_id(.:format)
 * @param {any} root_ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ui_library_module_path = /*#__PURE__*/ __route({"root_ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ui"],[2,[7,"/"],[2,[6,"library_modules"],[2,[7,"/"],[2,[3,"root_ref_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/energy-consumptions/units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const units_make_cs_energy_consumptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"energy-consumptions"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/:ref_id/untrash(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const untrash_make_cs_item_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"untrash"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/untrash(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const untrash_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"untrash"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:ref_id/update_available_date(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_available_date_make_db_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"update_available_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/settings/update_communication_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_communication_settings_users_account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"update_communication_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/settings/update_default_color_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_default_color_settings_users_account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"update_default_color_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/settings/update_default_unit_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_default_unit_settings_users_account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"update_default_unit_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/:ref_id/update_deprecated_date(.:format)
 * @param {any} ref_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_deprecated_date_make_db_module_path = /*#__PURE__*/ __route({"ref_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[3,"ref_id"],[2,[7,"/"],[2,[6,"update_deprecated_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/update_expiration_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_expiration_date_admin_companies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"update_expiration_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/update_expiration_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_expiration_date_admin_instances_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[6,"update_expiration_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/update_expiration_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_expiration_date_admin_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update_expiration_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/update_manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_manager_admin_companies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"update_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/instances/update_manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_manager_admin_instances_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"instances"],[2,[7,"/"],[2,[6,"update_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/update_manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_manager_admin_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/indicators_sets/update_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_order_database_indicators_sets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"indicators_sets"],[2,[7,"/"],[2,[6,"update_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /make/cs_items/update_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_order_make_cs_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"cs_items"],[2,[7,"/"],[2,[6,"update_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/settings/update_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_settings_users_account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"update_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /make/db-modules/update_workflow_and_publication_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_workflow_and_publication_status_make_db_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"make"],[2,[7,"/"],[2,[6,"db-modules"],[2,[7,"/"],[2,[6,"update_workflow_and_publication_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /database/flows/:id/use_report_in_db_modules(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const use_report_in_db_modules_database_db_flow_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"use_report_in_db_modules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /database/flows/:id/use_report_in_indicators(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const use_report_in_indicators_database_db_flow_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"database"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"use_report_in_indicators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_path = /*#__PURE__*/ __route({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/:notification_id/cancel(.:format)
 * @param {any} user_id
 * @param {any} notification_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_cancel_path = /*#__PURE__*/ __route({"user_id":{"r":true},"notification_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"notification_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notifications_path = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/openid_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_openid_connect_omniauth_authorize_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"openid_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/openid_connect/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_openid_connect_omniauth_callback_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"openid_connect"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/user_tokens(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_user_tokens_path = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_account_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/account/backup_factor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_account_backup_factor_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"backup_factor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/notification_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_account_notification_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"notification_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/second_factor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_account_second_factor_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"second_factor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/account/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_account_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/demo/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_demo_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/demo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_demo_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"demo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users_favorite_flows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_favorite_flow_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users_favorite_flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users_favorite_flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_favorite_flows_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users_favorite_flows"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users_favorite_modules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_favorite_module_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users_favorite_modules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users_favorite_modules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_favorite_modules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users_favorite_modules"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users_favorite_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_favorite_system_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users_favorite_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users_favorite_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_favorite_systems_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users_favorite_systems"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /telemetry/websockets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websockets_telemetry_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"telemetry"],[2,[7,"/"],[2,[6,"websockets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

